<div class="navbar-nav dropdown">
  <div class="menu-container">
    <div class="greeting">Hi, {{ username }}</div>
    <button
      class="nav-link"
      mat-button
      aria-label="Update your avatar here!"
      matTooltip="Update your avatar here!"
      (click)="openAvatarDialog()"
      *ngIf="isStudent"
    >
      <img class="avatar" [src]="avatar" alt="Avatar" />
    </button>
    <button
      class="nav-link"
      mat-button
      [matMenuTriggerFor]="beforeMenu"
      aria-label="Waffle Menu button"
      matTooltip="Waffle Menu button"
    >
      <img class="waffle-menu" [src]="waffleMenu" alt="Waffle Menu button" />
    </button>
    <mat-menu #beforeMenu="matMenu" xPosition="before">
      <div class="profile-dropdown-container">
        <div class="greeting-container">
          <img class="nav-link-img" [src]="catImg" alt="Cat" />
          <div>Hi {{ username }}</div>
        </div>
        <div class="nav-link-list">
          <ng-container
            *ngFor="let navLink of navLinks; trackBy: 'id' | trackByKey"
          >
            <a
              class="nav-link-item"
              [ngClass]="{ 'disabled-button': !navLink.link }"
              mat-menu-item
              [routerLink]="navLink.link"
            >
              <img
                class="nav-link-img"
                [src]="navLink.icon"
                [alt]="navLink.altText"
              />
              <div class="nav-link-label header-text">
                {{ navLink.label }}
              </div>
            </a>
          </ng-container>
          <ng-container
            *ngFor="let link of profileLinks; trackBy: 'id' | trackByKey"
          >
            <button
              class="nav-link-item"
              mat-menu-item
              [routerLink]="link.link"
            >
              <img class="nav-link-img" [src]="link.icon" [alt]="link.label" />
              <div class="nav-link-label header-text">
                {{ link.label }}
              </div>
            </button>
          </ng-container>
          <button
            class="nav-link-item"
            mat-menu-item
            (click)="openConfirmDialog()"
          >
            <img
              class="nav-link-img"
              src="assets/img/luggage.png"
              alt="Log Out button"
            />
            <div class="nav-link-label header-text">Log Out</div>
          </button>
        </div>
      </div>
    </mat-menu>
    <button
      class="nav-link"
      mat-button
      aria-label="Spend your sand dollars here!"
      matTooltip="Spend your sand dollars here!"
      (click)="openGachaDialog()"
      *ngIf="isStudent"
    >
      <app-coin-purse></app-coin-purse>
    </button>
  </div>
</div>
